import React, { useState } from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box } from '@mui/material';
const OtherTypeSelector = ({ noConsentOptionsDisabled, value, onChange, label = "Type" }) => {
    const [selectedValue, setSelectedValue] = useState(value || '');
    const handleChange = (event) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };
    return (React.createElement(Box, { className: 'mb-4', sx: { minWidth: 200 } },
        React.createElement("div", { className: "inline-flex" },
            React.createElement(FormControl, { component: "fieldset" },
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2 } },
                    React.createElement(FormLabel, { component: "span", sx: {
                            color: 'text.primary',
                            fontWeight: 500,
                            mb: 0,
                            '&.Mui-focused': {
                                color: 'text.primary',
                            }
                        } }, label),
                    React.createElement(RadioGroup, { row: true, "aria-labelledby": "type-selector-label", name: "type-selector", value: selectedValue, onChange: handleChange, sx: { gap: 2 } },
                        React.createElement(FormControlLabel, { disabled: noConsentOptionsDisabled, value: "follow-up", control: React.createElement(Radio, { size: "small" }), label: "Follow-Up", sx: {
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary'
                                }
                            } }),
                        React.createElement(FormControlLabel, { disabled: noConsentOptionsDisabled, value: "device-troubleshooting", control: React.createElement(Radio, { size: "small" }), label: "Device Troubleshooting", sx: {
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary'
                                }
                            } }),
                        React.createElement(FormControlLabel, { value: "non-billable", control: React.createElement(Radio, { size: "small" }), label: "Administrative (Non-Billable)", sx: {
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary'
                                }
                            } })))))));
};
export default OtherTypeSelector;
